var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.492 6.995h-.024a.31.31 0 00-.31.31v3.55h-.643v-3.55a.31.31 0 00-.31-.31h-.023a.31.31 0 00-.31.31v3.55h-.643v-3.55a.31.31 0 00-.31-.31h-.024a.31.31 0 00-.31.31v3.55h-.642v-3.55a.31.31 0 00-.31-.31h-.024a.31.31 0 00-.31.31v5.607A1.797 1.797 0 0019 14.333a1.671 1.671 0 01.65 1.325v8.437a.9.9 0 101.8 0v-8.436a1.671 1.671 0 01.65-1.326 1.796 1.796 0 00.702-1.42V7.304a.31.31 0 00-.31-.31zm-5.478 0v5.995a2.877 2.877 0 01-.767 1.962 3.331 3.331 0 01-.275.263 4.352 4.352 0 01-2.374 1v7.796h2.406a.492.492 0 010 .984h-5.796a.492.492 0 110-.984h2.406v-7.796a4.352 4.352 0 01-2.374-1 3.317 3.317 0 01-.275-.263 2.877 2.877 0 01-.767-1.962V6.995z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm0 27a13 13 0 1113-13 13 13 0 01-13 13z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--fork-glass-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ForkGlassCircleIcon';
export default Icon;